import type { FC } from "react";
import type { JSX } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopupHoverContainer } from "@similarweb/ui-components";

import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { LinkCell } from "pro-features/components/Workspace/TableCells/LinkCell";

const LinkContainer = styled.div`
    margin-left: auto;
    a {
        width: 100%;
        color: ${colorsPalettes.blue[400]};
    }
`;

const LinkCellContainer = styled(LinkContainer)`
    margin-left: auto;
    width: max-content;
`;

const TooltipContainer = styled.div``;

// Temporary solution for new table usage
interface ILinkCellRightAlignedBasicProps {
    value: string | number;
    row: any;
    onClick?: () => void;
    tooltipContentCallback: () => string | JSX.Element;
    getLinkCallback?: (row: any) => string;
    tooltipPlacement?: string;
    enabledTooltip?: boolean;
    cssClass?: string;
    tooltipMaxWidth?: number;
    displayLongText?: boolean;
}

interface ILinkCellRightAlignedProps extends Partial<ITableCellProps> {
    getLinkCallback?: (row: any) => string;
    tooltipContentCallback: () => string | JSX.Element;
    tooltipPlacement?: string;
    enabledTooltip?: boolean;
    cssClass?: string;
    tooltipMaxWidth?: number;
    onClick?: () => void;
    displayLongText?: boolean;
}

export const LinkCellRightAligned: FC<ILinkCellRightAlignedProps | ILinkCellRightAlignedBasicProps> = (props) => {
    const {
        value,
        row,
        getLinkCallback,
        tooltipContentCallback,
        tooltipPlacement = "top",
        enabledTooltip = true,
        cssClass = "PlainTooltip-element",
        tooltipMaxWidth = 220,
        displayLongText = false,
        onClick,
    } = props;

    const popupHoverContent = (): JSX.Element => {
        return <TooltipContainer>{tooltipContentCallback()}</TooltipContainer>;
    };

    return (
        <PopupHoverContainer
            config={{
                enabled: enabledTooltip,
                placement: tooltipPlacement,
                maxWidth: tooltipMaxWidth,
                cssClass: cssClass,
            }}
            content={popupHoverContent}
        >
            {displayLongText ? (
                getLinkCallback ? (
                    <LinkContainer>
                        <LinkCell
                            href={getLinkCallback(row)}
                            value={value}
                            onClick={onClick}
                        />
                    </LinkContainer>
                ) : (
                    <>{value}</>
                )
            ) : (
                <LinkCellContainer>
                    {getLinkCallback ? (
                        <LinkCell
                            href={getLinkCallback(row)}
                            value={value}
                            onClick={onClick}
                        />
                    ) : (
                        <>{value}</>
                    )}
                </LinkCellContainer>
            )}
        </PopupHoverContainer>
    );
};

LinkCellRightAligned.displayName = "LinkCellRightAligned";
